var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogodash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 49,
    viewBox: "0 0 129 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.9222 34.4064V14.1423H88.4453V34.4064H82.9222Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4981 34.4064L49.7542 14.1423H54.8125L63.0688 34.4064H57.2253L56.1788 31.7611H48.3879L47.3124 34.4064H41.4981ZM49.8415 27.4876H54.7254L52.2833 21.2092L49.8415 27.4876Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7624 11.4248C70.4418 7.4778 67.016 1.68954 64.3429 1.65209C62.6782 1.62871 60.8941 4.00844 59.5724 7.95539C59.1382 9.26893 58.7793 10.6062 58.4975 11.9606C58.3847 12.4961 58.2793 13.0445 58.1812 13.606C57.9259 15.0725 57.7244 16.6177 57.5806 18.2197C57.5187 18.8976 57.468 19.5869 57.4278 20.2836C57.3522 21.5889 57.3141 22.9231 57.3141 24.276C57.3141 25.6289 57.3522 26.9632 57.4278 28.2684C56.8449 27.8839 56.2748 27.4957 55.7174 27.1037C55.6793 26.1727 55.6607 25.228 55.6607 24.276C55.6607 23.3241 55.6793 22.3795 55.7174 21.4483C55.7443 20.7456 55.7822 20.0501 55.8311 19.3617C55.9747 17.2487 56.2318 15.1448 56.6012 13.0593C56.7003 12.5033 56.8078 11.959 56.9235 11.4263C57.2106 10.076 57.5716 8.74259 58.0047 7.4319C59.6096 2.63953 61.8607 0 64.3431 0C66.8255 0 69.0757 2.63953 70.6806 7.4319C71.1138 8.74268 71.4752 10.0761 71.7631 11.4263",
    fill: "url(#paint0_linear_204_17)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9225 37.1242C58.2431 41.0711 61.6689 46.8594 64.342 46.8969C66.0067 46.9202 67.7908 44.5405 69.1125 40.5936C69.5467 39.28 69.9056 37.9428 70.1874 36.5884C70.3002 36.053 70.4056 35.5046 70.5037 34.943C70.759 33.4764 70.9605 31.9313 71.1043 30.3292C71.1662 29.6514 71.2169 28.962 71.2572 28.2654C71.3327 26.9601 71.3708 25.6258 71.3708 24.2729C71.3708 22.92 71.3327 21.5858 71.2572 20.2805C71.84 20.665 72.4101 21.0533 72.9675 21.4453C73.0056 22.3762 73.0242 23.321 73.0242 24.2729C73.0242 25.2249 73.0056 26.1694 72.9675 27.1006C72.9406 27.8033 72.9028 28.4989 72.8538 29.1872C72.7102 31.3003 72.4531 33.4041 72.0837 35.4896C71.9846 36.0456 71.8771 36.59 71.7614 37.1227C71.4743 38.4729 71.1134 39.8064 70.6802 41.117C69.0753 45.9094 66.8242 48.549 64.3418 48.549C61.8595 48.549 59.6092 45.9094 58.0043 41.117C57.5711 39.8063 57.2097 38.4728 56.9218 37.1227",
    fill: "url(#paint1_linear_204_17)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7605 37.1252C75.8397 37.954 82.565 37.8829 83.9339 35.5861C84.7864 34.156 83.6176 31.4212 80.8596 28.303C79.9392 27.2702 78.9607 26.2909 77.9287 25.3696C77.5215 25.0043 77.0996 24.639 76.6628 24.2735C75.5204 23.3192 74.2831 22.372 72.9677 21.4467C72.4114 21.054 71.8413 20.6659 71.2573 20.2824C70.1648 19.5642 69.0312 18.8659 67.8566 18.1876C66.6849 17.5112 65.5104 16.8771 64.3422 16.2898C64.9666 15.9773 65.5879 15.6777 66.2063 15.3909C67.0317 15.8239 67.8574 16.2785 68.6834 16.7548C69.5094 17.2311 70.3162 17.7188 71.1039 18.2179C71.6989 18.5931 72.2823 18.9737 72.854 19.3597C74.6123 20.5405 76.3058 21.8151 77.9272 23.1778C78.359 23.5417 78.7766 23.9069 79.18 24.2735C80.206 25.1971 81.1804 26.1765 82.0989 27.2071C85.4468 30.9932 86.6072 34.2623 85.366 36.4123C84.1248 38.5623 80.7137 39.1908 75.7609 38.1847C74.4091 37.9041 73.0737 37.55 71.7605 37.1239",
    fill: "url(#paint2_linear_204_17)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9244 11.4238C52.8451 10.595 46.1199 10.6661 44.751 12.9629C43.8984 14.393 45.0673 17.1278 47.8252 20.246C48.7456 21.2788 49.7242 22.2581 50.7561 23.1794C51.1633 23.5447 51.5853 23.91 52.022 24.2755C53.1645 25.2298 54.4017 26.177 55.7172 27.1023C56.2734 27.495 56.8435 27.8831 57.4275 28.2666C58.5201 28.9848 59.6537 29.6831 60.8282 30.3614C61.9999 31.0378 63.1744 31.6719 64.3426 32.2592C63.7182 32.5716 63.0969 32.8712 62.4786 33.1581C61.6532 32.7251 60.8274 32.2705 60.0014 31.7942C59.1754 31.3179 58.3686 30.8302 57.581 30.3311C56.9859 29.9559 56.4025 29.5752 55.8308 29.1893C54.0725 28.0085 52.379 26.7339 50.7577 25.3712C50.3258 25.0073 49.9082 24.6421 49.5048 24.2755C48.4789 23.3518 47.5044 22.3725 46.586 21.3419C43.2381 17.5558 42.0777 14.2867 43.3188 12.1367C44.56 9.98668 47.9711 9.35819 52.9239 10.3643C54.2757 10.6449 55.6112 10.999 56.9244 11.4251",
    fill: "url(#paint3_linear_204_17)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1805 24.2755C81.9378 21.1579 85.2383 15.2971 83.9344 12.9635C83.1223 11.5102 80.1693 11.1551 76.0903 11.9837C74.736 12.2646 73.3987 12.6224 72.0851 13.0553C71.5655 13.2255 71.0381 13.4083 70.5029 13.6037C69.1052 14.1157 67.6668 14.7139 66.2072 15.3904C65.5891 15.6756 64.9679 15.9754 64.3434 16.2898C63.1743 16.8771 62.0006 17.5112 60.829 18.1876C59.6573 18.8639 58.5209 19.5643 57.4282 20.2824C57.4698 19.5853 57.521 18.8973 57.5817 18.2185C58.3692 17.72 59.176 17.2323 60.0022 16.7555C60.8283 16.2786 61.654 15.8239 62.4793 15.3915C63.1015 15.0636 63.7229 14.7487 64.3434 14.4467C66.245 13.5144 68.1955 12.6851 70.1864 11.9624C70.7175 11.7702 71.2427 11.5911 71.7618 11.4251C73.0747 10.9986 74.4099 10.6444 75.7616 10.3643C80.7144 9.35819 84.126 9.98777 85.3671 12.1376C86.6083 14.2874 85.4475 17.5558 82.0996 21.3422C81.1809 22.3726 80.2066 23.3521 79.1812 24.2763",
    fill: "url(#paint4_linear_204_17)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5044 24.2734C48.479 25.1977 47.5047 26.1772 46.586 27.2076C43.2381 30.9939 42.0777 34.263 43.3185 36.4122C44.5592 38.5614 47.9712 39.1916 52.924 38.1855C54.2757 37.9054 55.6109 37.5512 56.9238 37.1247C57.4423 36.9578 57.9675 36.7787 58.4992 36.5873C60.4901 35.8649 62.4407 35.0357 64.3425 34.1035C64.9618 33.8018 65.5831 33.4869 66.2065 33.1587C67.0319 32.7257 67.8577 32.271 68.6837 31.7948C69.5097 31.3185 70.3165 30.8308 71.1041 30.3317C71.1656 29.6533 71.2167 28.9654 71.2576 28.2678C70.165 28.986 69.0314 29.6843 67.8569 30.3626C66.6852 31.039 65.5107 31.6731 64.3425 32.2604C63.719 32.5736 63.0977 32.8734 62.4786 33.1598C61.0195 33.8363 59.5806 34.4345 58.1829 34.9465C57.6489 35.1417 57.1215 35.3244 56.6008 35.4949C55.2871 35.9278 53.9499 36.2856 52.5956 36.5666C48.5166 37.3951 45.5635 37.04 44.7514 35.5867C43.4475 33.2531 46.748 27.3929 49.5053 24.2747",
    fill: "url(#paint5_linear_204_17)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3106 8.23921C70.9665 8.23921 72.3089 6.89684 72.3089 5.24094C72.3089 3.58504 70.9665 2.24268 69.3106 2.24268C67.6547 2.24268 66.3124 3.58504 66.3124 5.24094C66.3124 6.89684 67.6547 8.23921 69.3106 8.23921Z",
    fill: "url(#paint6_linear_204_17)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3465 32.8725C84.7295 32.8725 85.8507 31.7513 85.8507 30.3682C85.8507 28.9852 84.7295 27.864 83.3465 27.864C81.9635 27.864 80.8423 28.9852 80.8423 30.3682C80.8423 31.7513 81.9635 32.8725 83.3465 32.8725Z",
    fill: "url(#paint7_linear_204_17)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8122 14.1423H49.7549L41.4977 34.4064L46.2433 25.5214L49.5037 24.2744L46.7131 34.4064H47.3128L48.3888 31.7609H56.1783L57.2262 34.4064H63.0694L54.8122 14.1423ZM49.8415 27.4872L52.2836 21.2066L54.7256 27.4872H49.8415Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9222 26.243V14.1423H88.4453V26.2421L82.9222 26.243Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2747 17.4574L15.5246 20.5966C14.3618 19.4048 12.8792 18.7943 11.0476 18.7943C10.3215 18.7796 9.59981 18.911 8.92549 19.1807C8.25116 19.4505 7.63796 19.8531 7.12232 20.3645C6.09734 21.4137 5.52351 22.8223 5.52351 24.2891C5.52351 25.7558 6.09734 27.1644 7.12232 28.2136C8.17472 29.2268 9.58617 29.7809 11.0468 29.7542C12.8493 29.7542 14.2446 29.1729 15.2622 28.0101V26.6438H10.0294V22.0506H20.0296V30.1909C18.1401 32.8943 14.7969 34.6966 11.0468 34.6966C7.96528 34.6966 5.34899 33.7079 3.19787 31.7306C1.07621 29.7538 0 27.2829 0 24.2885C0 21.2942 1.07556 18.8233 3.19787 16.8464C5.34899 14.8406 7.96535 13.8523 11.0468 13.8523C14.3327 13.8527 17.0944 15.0445 19.2747 17.4574Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.704 34.4065V14.1424H31.9194C32.8693 14.1229 33.8135 14.2929 34.6969 14.6423C35.5804 14.9917 36.3854 15.5136 37.0649 16.1774C37.7478 16.8044 38.2901 17.569 38.6558 18.4209C39.0215 19.2728 39.2024 20.1925 39.1866 21.1194C39.1866 23.7068 37.8203 25.9451 35.7272 26.9044L40.7859 34.4065H34.4486L30.3204 28.0982H28.2273V34.4065H22.704ZM28.2273 23.6793H31.3089C32.7915 23.6793 33.6928 22.8072 33.6928 21.2956C33.6928 20.0164 32.8497 19.1443 31.774 19.1443H28.2273V23.6793Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6902 34.4064L59.4929 14.1423H65.336L70.2491 26.5556L75.1322 14.1423H80.9755L72.7774 34.4064H67.6902Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8287 34.4064V19.1434H90.3635V14.1423H106.701V19.1434H101.352V34.4064H95.8287Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.356 45.2314V38.0502L107.711 24.9673H113.641L118.089 32.8456L122.537 24.9673H128.467L120.822 38.0493V45.2314H115.356Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8911 28.4943C54.1342 28.4943 55.142 27.4865 55.142 26.2434C55.142 25.0002 54.1342 23.9924 52.8911 23.9924C51.6479 23.9924 50.6401 25.0002 50.6401 26.2434C50.6401 27.4865 51.6479 28.4943 52.8911 28.4943Z",
    fill: "url(#paint8_linear_204_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_17",
    x1: 63.7119,
    y1: 28.2684,
    x2: 63.7119,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_17",
    x1: 64.973,
    y1: 48.549,
    x2: 64.973,
    y2: 20.2805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_204_17",
    x1: 81.3125,
    y1: 39.3038,
    x2: 65.4619,
    y2: 15.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_204_17",
    x1: 61.568,
    y1: 33.856,
    x2: 45.7173,
    y2: 10.3617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_204_17",
    x1: 66.7228,
    y1: 25.6424,
    x2: 69.6432,
    y2: 5.86548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_204_17",
    x1: 51.2189,
    y1: 41.5288,
    x2: 54.1392,
    y2: 21.7521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D68FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_204_17",
    x1: 70.8098,
    y1: 7.83744,
    x2: 67.8115,
    y2: 2.64444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_204_17",
    x1: 84.5986,
    y1: 32.5369,
    x2: 82.0944,
    y2: 28.1996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBC8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_204_17",
    x1: 54.0165,
    y1: 28.1926,
    x2: 51.7656,
    y2: 24.2941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6420FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9870FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogodash);
export default __webpack_public_path__ + "static/media/logodash.3a5915d769ecbb883d4cbb54c0620e7f.svg";
export { ForwardRef as ReactComponent };